var __jsx = React.createElement;
import React from 'react';
import { BillIncluded, Wrapper } from './styles';
import CheckedBullet from '@spa/shared/svg/check-bullet-green';
import CrossBullet from '@spa/shared/svg/cross-bullet';
import { theme } from '@spa/offer/theme';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
var BillItem = function BillItem(_ref) {
  var _bill$maximum, _bill$maximum$max;
  var name = _ref.name,
    bill = _ref.bill,
    t = _ref.t,
    formatMoney = _ref.formatMoney;
  var colors = theme.servicesExpensesSection.billsGridItem.colors;
  var hasMaxAmount = (_bill$maximum = bill.maximum) === null || _bill$maximum === void 0 ? void 0 : (_bill$maximum$max = _bill$maximum.max) === null || _bill$maximum$max === void 0 ? void 0 : _bill$maximum$max.amount;
  return __jsx(Wrapper, null, __jsx("span", null, t(capitalizeFirstLetter(name))), __jsx("span", null, bill.included ? __jsx(BillIncluded, {
    hasMaxAmount: hasMaxAmount
  }, hasMaxAmount ? __jsx(React.Fragment, null, t('Up to'), " ", formatMoney(bill.maximum.max.amount, bill.maximum.max.currency_code), __jsx("span", null, "/", t('month'))) : __jsx(React.Fragment, null, __jsx(CheckedBullet, {
    fillColor: colors.billIncluded
  }), __jsx("span", null, t('Included in the price')))) : __jsx(React.Fragment, null, __jsx(CrossBullet, null), __jsx("span", null, t('Not included in the price')))));
};
export default BillItem;